
import { reactive, ref, computed, toRaw } from 'vue';
import { GET, POST } from '@/packge/http';
import Icons from '@/assets/images/web';
import Common from '@/utils/common';
import { message } from 'ant-design-vue';
import store from '@/store';

export let visible = ref(false);
export let appItem = reactive({ label: '', appId: '', icon: '' });
export let productList = reactive({
  list: []
});

/** 获取授权应用列表 */
export function getAuthList () {
  GET({
    url: '/userApp/list',
    params: {}
  }).then(({ data }) => {
    productList.list = data && data.map(item => ({
      label: item.label,
      icon: item.icon,
      value: '已授权',
      change: '取消',
      appId: item.value
    }));
  });
}

/** 打开弹窗 */
export function changeAuth (item) {
  for (let ele in appItem) {
    appItem[ele] = item[ele];
  }
  visible.value = true;
}
/** 解绑授权应用 */
export function cancelAuth () {
  const uid = computed(() => store.state.userInfo.uid);
  console.log('uid: ', uid.value);

  POST({
    url: '/userApp/unBindApp',
    params: { appId: appItem.appId, userId: uid.value }
  }).then(({ data }) => {
    message.success('取消成功');
    visible.value = false;
    getAuthList();
  });
}
